module.exports = __webpack_public_path__ + "static/media/logo-inverse.fdd5e80e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-inverse.svg
// module id = 175
// module chunks = 0